module.exports = __webpack_public_path__ + "static/media/SathishKumar.22abced3.jpg";